import { Page } from '@optools/components/layout/page';
import { querySchema } from '@optools/tools/esni/schemas/details';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_auth/esni')({
  component: RouteComponent,
  validateSearch: zodValidator(querySchema),
  search: {
    middlewares: [stripSearchParams({ details: '' })],
  },
  beforeLoad: authorizedRouteLoader('esni'),
});
/* eslint-enable perfectionist/sort-objects */

function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'Media ID', to: '/esni/media' },
        { label: 'Policies', to: '/esni/policies' },
        { label: 'Audiences', to: '/esni/audiences' },
        { label: 'Rules', to: '/esni/rules' },
      ]}
      title="ESNI Management"
    />
  );
}
